import { Box, Text } from "grommet"

export default function MicroAppLoading({ name }) {
  return (
    <Box fill flex={false} pad={{ top: "xlarge" }}>
      <Text textAlign="center">{`${name} loading...`}</Text>
    </Box>
  )
}
